import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import DownArrow from "../../assets/icons/downarrow.svg";
import "../../assets/styles/local/ProductStockEntry.css";
import OrderPickingIcon from "../../assets/icons/product-icon-order.svg";
import calendar from "../../assets/icons/Calendar3.svg";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import PlusIcon from "../../assets/icons/plus-circle-white.svg";
import Header from "../../layouts/Header";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import AppDatePicker from "../Common/AppDatePicker";
import AddItems from "./AddItems";
import { useDispatch, useSelector } from "react-redux";
import { UpdateCheckCountStock } from "../../redux/actions/action";
import { UPDATE_CHECK_COUNT_STOCK } from "../../redux/constants/type";
import CancelWarningModal from "../Dailogs/CancelWarningModal";
import RouteLeavingGuard from "../Common/RouteLeavingGuard";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const ProductStockEntry = () => {
  const screenSize = useScreenSize();
  const history = useHistory();
  const dispatch = useDispatch();
  const [query, setQuery] = useState("");
  const [openAddItem, setOpenAddItem] = useState(false);
  const [typeField, setTypeField] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [dataList, setDataList] = useState([]);
  const [calendarIsOpenArray, setCalendarIsOpenArray] = useState(
    new Array(dataList.length).fill(false),
  );
  const updateCheckCountStock = useSelector(
    (state) => state.user.updateCheckCountStock,
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Stock Levels").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const addMissingItems = (items) => {
    const updatedItems = items.map((item) => ({
      ...item,
      qtyCount: "",
      dateOfCount: new Date(),
    }));
    setDataList((prevDataList) => [...prevDataList, ...updatedItems]);
    setTypeField(true);
  };

  const handleDelete = (productPartid) => {
    const updatedStock = dataList.filter(
      (item) => item.productPartid !== productPartid,
    );
    setDataList(updatedStock);
  };
  const handleQtyCountChange = (e, index) => {
    const inputValue = e.target.value;
    setTypeField(true);
    if (inputValue === "" || (/^\d+$/.test(inputValue) && inputValue >= "0")) {
      // Update state if the input is an empty string or a valid non-negative integer
      let data = [...dataList];
      data[index]["qtyCount"] = inputValue;
      setDataList(data);
    }
  };

  const AddEntryFuc = () => {
    const payload = dataList
      .filter(({ qtyCount }) => qtyCount.length > 0)
      .map(({ qtyCount, dateOfCount, productPartid }) => ({
        dateOfCount,
        qtyCount,
        productPartId: productPartid,
      }));
    dispatch(UpdateCheckCountStock(payload));
  };
  useEffect(() => {
    if (updateCheckCountStock?.status === true) {
      history.push("/stock");
      dispatch({
        type: UPDATE_CHECK_COUNT_STOCK,
        data: {},
      });
    }
  }, [updateCheckCountStock]);
  const handleClose = () => setModalShow(false);

  const handleCancel = (e) => {
    history.goBack();
  };
  return (
    <>
      <Header
        leftComponent={
          <div className="stock-heading-box">
            <div
              className="stock-heading cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </div>
            <div className="box-title product_stock_entry_title">
              {/* Product Stock Entry */}
              {t("Product Stock Entry")}
            </div>
          </div>
        }
        setQuery={setQuery}
      />
      <div className="container-fluid">
        <div className=" main-wrapper mb-4">
          <div className="CountStock-action d-flex justify-content-end mb-4">
            <button className="cancel-btn" onClick={() => setModalShow(true)}>
              {/* Cancel */}
              {t("Cancel")}
            </button>
            <button className="add-btn ms-3" onClick={() => AddEntryFuc()}>
              {/* Add */}
              {t("Add")}
            </button>
          </div>
          <div
            className={
              screenSize === "xs"
                ? "Count-Stock-content-mobile"
                : "Count-Stock-content position-relative"
            }
          >
            <table className="table table-borderless stock-entry tableOverflow">
              <thead>
                <tr className="text-Headings">
                  <th
                    scope="col"
                    className="d-flex align-items-center gap-2 product-items-th"
                  >
                    <img src={OrderPickingIcon} alt="" />
                    <span>
                      {/* Product */}
                      {t("Product")}
                    </span>
                  </th>
                  <th className="product-item-id" scope="col ">
                    {/* Item ID */}
                    {t("Item ID")}
                  </th>
                  <th className="product-color-qty" scope="col">
                    {/* Color */}
                    {t("Color")}
                  </th>
                  <th className="product-color-qty" scope="col">
                    {t("Qty")}
                    {/* Qty */}
                  </th>
                  <th className="product-color-date" scope="col">
                    {/* Date */}
                    {t("Date")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {dataList?.map((item, index) => (
                  <tr key={index} style={{ marginBottom: "5px" }}>
                    <td className="product-items">{item.productPartName}</td>
                    <td className="product-item-id">
                      <input
                        className="stock-entry-input-id"
                        type="text"
                        value={item.productPartCode}
                        disabled
                      />
                    </td>
                    {/* <td className="product-color-qty position-relative">
                                                <div
                                                    style={{
                                                        top: "0",
                                                        position: "relative",
                                                        height: "49px",
                                                        left: "-9px",
                                                    }}
                                                >
                                                    <StockLevelColorPickers
                                                        onUpdateColor={handleStockData}
                                                        index={1}
                                                        productcolor={"red"}
                                                    />
                                                </div>
                                            </td> */}
                    <td className="product-color-qty d-flex justify-content-center">
                      <div
                        className="asc_Color_Code"
                        style={{
                          backgroundColor: item?.color,
                        }}
                      ></div>
                    </td>
                    <td className="product-color-qty">
                      <input
                        className="stock-entry-input"
                        type="text"
                        value={item.qtyCount}
                        onChange={(e) => handleQtyCountChange(e, index)}
                        placeholder="0"
                        min="0"
                        pattern="\d+"
                      />
                    </td>
                    <td className="product-color-date">
                      <div className="stock-entry-input d-flex align-items-center">
                        <img
                          className="calendarIcon"
                          onClick={() => {
                            const updatedArray = [...calendarIsOpenArray];
                            updatedArray[index] = !updatedArray[index];
                            setCalendarIsOpenArray(updatedArray);
                          }}
                          src={calendar}
                          alt=""
                        />

                        <AppDatePicker
                          // open={calendarIsOpenArray[index]}
                          selected={item.dateOfCount}
                          onChange={(e) => {
                            setTypeField(true);
                            let data = [...dataList];
                            data[index]["dateOfCount"] = e;
                            setDataList(data);
                            setCalendarIsOpenArray((prevArray) => {
                              const newArray = [...prevArray];
                              newArray[index] = false;
                              return newArray;
                            });
                          }}
                          onSelect={(d, event) => {
                            event.preventDefault();
                          }}
                          dateFormat="dd/MM/yyyy"
                          className="ps-2"
                        />
                      </div>
                    </td>
                    <img
                      src={DeleteIcon}
                      alt=""
                      className="cursor-pointer"
                      onClick={() => handleDelete(item.productPartid)}
                    />
                  </tr>
                ))}
                <tr>
                  <td
                    className="product-items cursor-pointer"
                    onClick={() => {
                      setOpenAddItem(!openAddItem);
                    }}
                  >
                    {/* Type or scan an item */}
                    {t("Type or scan an item")}
                  </td>
                  <td className="product-item-id">
                    <input
                      className="stock-entry-input-id"
                      type="text"
                      value={""}
                      disabled
                    />
                  </td>
                  <td className="product-color-qty position-relative">
                    <div
                      style={{
                        top: "0",
                        position: "relative",
                        height: "49px",
                        left: "-9px",
                      }}
                    ></div>
                  </td>
                  <td className="product-color-qty">
                    <input
                      className="stock-entry-input-id"
                      type="text"
                      value={""}
                      disabled
                      placeholder="0"
                    />
                  </td>
                  <td className="product-color-date">
                    <div className="stock-entry-input d-flex align-items-center">
                      <img className="calendarIcon" src={calendar} alt="" />
                      <AppDatePicker
                        disabled
                        // open={calendarIsOpen}
                        selected={startDate}
                        // onChange={(val) => {
                        //     setStartDate(val);
                        //     setCalendarIsOpen(false);
                        // }}
                        // onSelect={(d, event) => {
                        //     event.preventDefault();
                        // }}
                        dateFormat="dd/MM/yyyy"
                        className="ps-2"
                      />
                    </div>
                  </td>
                  <img src={PlusIcon} alt="" className="cursor-pointer" />
                </tr>
              </tbody>
            </table>
            {openAddItem && (
              <AddItems
                setOpenAddItem={setOpenAddItem}
                openAddItem={openAddItem}
                addMissingItems={addMissingItems}
              />
            )}
          </div>
        </div>
      </div>
      {modalShow && (
        <CancelWarningModal
          show={modalShow}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}
      <RouteLeavingGuard
        when={typeField}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          if (typeField) {
            if (!["/stock"].includes(location.pathname)) {
              return true;
            }
          }
          return false;
        }}
      />
    </>
  );
};

export default ProductStockEntry;
